export { default as ThemedLink, style } from './themed-link';
